import { defineComponent as _defineComponent } from 'vue'
import ProductLevelIcon from "~/components/ProductLevelIcon.vue";
import VResponsive from "~/components/VResponsive/VResponsive.vue";
import {buildProductDetailLink} from '~/utils/product'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    no: null,
    layout: null,
    name: null,
    price: null,
    image: null,
    currencyLabel: null,
    levelPic: null,
    imageRatio: { default: 180 },
    imageHeight: null,
    productType: null,
    isTripartiteProduct: null
  },
  setup(__props: any) {



return { __sfc: true,ProductLevelIcon, VResponsive, buildProductDetailLink }
}

})